import React, { Component } from 'react'
import { Button, Icon } from '@tinper/next-ui'
import { getMscByDomainKey } from 'ynf-core-engine/request';
import { isDesigner } from "@src/utils/refer_context/formatter";
import { loadJS, isJDiwork, getFileUrl } from '@utils'
import { v4 as uuid } from 'uuid'
import { getFieldId } from '../../utils/tool'
import HandWritingBoard from './HandWritingBoard';
import './style/index.less';

export default class HandWrittenSignature extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showHandWritingBoard: false,
      showBtn: true,
      imageUrl: ''
    }
    this.objectName = this.getObjectName()
    this.authId = props.pageStore?.query?.serviceCode || "ybbase"
  }

  componentDidMount () {
    if (this.props.value) {
      this.loadFileResources(() => {
        this.setUrl(this.props.value)
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      if (nextProps.value) {
        this.setUrl(nextProps.value)
      } else {
        this.setState({
          imageUrl: '',
          showBtn: true
        })
      }
    }
  }

  getObjectName () {
    const { domainKey, pageStore, objectName, defaultObjectName } = this.props
    let objectNameValue = objectName || defaultObjectName || domainKey || getMscByDomainKey?.(pageStore?.query?.domainKey) || pageStore?.query?.domainKey || 'developplatform';
    if (!(objectName || defaultObjectName || domainKey) && objectName === 'developplatform' && pageStore?.query?.domainKey === 'developplatform') {
      objectNameValue = 'iuap-yonbuilder-runtime'
    }
    return objectNameValue
  }

  async setUrl(value) {
    try {
      const { pageStore } = this.props;
      const file = await window.YYCooperationBridge?.YYFormFileGetAllListByObjectIdV2?.({
        searchList: [{ 
          businessId: value, 
          objectName: this.objectName
        }],
        extraParams: { authId: this.authId }
      });
      if (file && file.length > 0) {
        this.setState({
          imageUrl: file[0]?.filePath,
          showBtn: false
        });
      }
    } catch (err) {
      console.error("Error setting URL:", err);
    }
  }

  // 加载协同js等资源
  loadFileResources = (callback) => {
    const isBridgeReady = () => window.YYCooperationBridge?.ready && typeof window.YYCooperationBridge.ready === 'function';
    if ((isJDiwork() && window.YYCooperationBridge) || window.uploadFileLoading) {
      const timer = setInterval(() => {
        // 如果js加载完毕，清除定时器，并执行init
        // console.log('%c 加载文件js')
        if (isBridgeReady()) {
          clearInterval(timer);
          window.YYCooperationBridge?.ready?.(() => {
            // console.log('%c 加载文件js', 'color: #d90890')
            callback();
          });
        }
      }, 100)
    } else {
      window.uploadFileLoading = true;
      loadJS(
        getFileUrl(),
        'ybUploadFileservice',
        () => callback(),
        () => {
          let flag = false
          window.YYCooperationBridge?.ready?.(() => {
            flag = true
            window.uploadFileLoading = false
          });
          return flag
        }
      )
    }
  }

  showHandWritingBoard = () => {
    this.setState({ showHandWritingBoard: true })
  }

  base64ToFile (dataurl, filename) {
    if (!dataurl || typeof dataurl !== 'string' || !filename) return
    try {
      const arr = dataurl.split(',');
      if (arr.length >= 2) {
        const mimeMatch = arr[0].match(/:(.*?);/);
        if (!mimeMatch || !mimeMatch[1]) return
        const mime = mimeMatch[1];
        const bstr = atob(arr[1]);
        const n = bstr.length;
        const u8arr = new Uint8Array(n);
        for (let i = 0; i < n; i++) {
          u8arr[i] = bstr.charCodeAt(i);
        }
        return new File([u8arr], filename, { type: mime });
      }
    } catch (error) {
      console.error('Failed to convert Base64 to File:', error);
    }
  }

  UploadFiles = (file) => {
    if (!file) return;
    this.loadFileResources(() => {
      const uid = uuid()
      window.YYCooperationBridge?.YYUploadFiles?.({
        files: [file],
        authId: this.authId,  // 传错会报权限不足
        appCode: this.objectName,
        businessId: uid,
        onFailed: error => {
          console.log("come in onFailed--", error);
        },
        onSuccess: file => {
          console.log("onSuccess-file----", file);
          this.props?.onChange?.(uid)
          this.setState({
            imageUrl: file.filePath,
            showBtn: false
          })
        }
      });
    })
  }

  handleSave = (value) => { // 保存值
    const file = this.base64ToFile(value, 'image.png')
    this.UploadFiles(file)
    this.setState({
      showHandWritingBoard: false
    })
  }

  handleCancel = (value) => { // 关闭按钮不清空值
    this.handleSave(value)
  }

  deleteImg = () => {
    this.setState({
      imageUrl: '',
      showBtn: true
    })
    this.props?.onChange?.('')
  }

  getContainer = () => {
    const { readOnly = false, disabled } = this.props;
    const { showBtn, showHandWritingBoard, imageUrl } = this.state
    return (
      <div className='signature-container'>
        {showBtn && <Button disabled={disabled || readOnly || isDesigner(this.props)} fieldid={getFieldId() + 'HandWritingBoard'} icon='uf-pencil' onClick={this.showHandWritingBoard}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1B915FF605380016', '添加签名')}</Button>}
        {showHandWritingBoard && <HandWritingBoard onSave={(value) => this.handleSave(value)} onCancel={(value) => this.handleCancel(value)} />}
        {imageUrl && <div className='signature-img'><img className='img' src={this.state.imageUrl} /><Icon className='img-delete' type='uf-reduce-c' onClick={(e) => this.deleteImg(e)} /></div>}
      </div>
    )
  }

  renderBrowse = () => {
    const dom = this.state.imageUrl ? <div className='signature-img'><img className='img' src={this.state.imageUrl} /></div> : '--'
    return <div className='signature-container'>{dom}</div>
  }

  render() {
    const { visible = true, readOnly, pageStore = {} } = this.props;
    if (!visible) return null
    if ((!isDesigner(this.props) && readOnly) || pageStore.query?.mode == 'browse') return this.renderBrowse()
    return this.getContainer()
  }
}
